import { Controller } from "react-hook-form";
import Plate from "Components/Plate";
import React from "react";
import { format } from "react-string-format";
import { useTranslation } from "react-i18next";

const PlateInput = (props: any) => {
  const [t] = useTranslation();

  return (
    <React.Fragment>
      <Controller
        control={props.control}
        name={props.name}
        rules={{
          ...props.rules,
          validate: (e) => {
            if (props?.rules["required"] == true) {
              let message = "";
              if (!e) return "null,";

              //  CAR or TEMPORARY
              if (e.type == "CAR" || e.type == "TEMPORARY") {
                if (e.type == "CAR") {
                  if (!e.cityCode) message += "cityCode,";
                  else if (e.cityCode.length !== 2) message += "cityCodeLen,";
                  else if (Number(e.cityCode.substring(0, 1)) == 0)
                    message += "cityCodeInvalid,";
                }

                if (!e.carSerial) message += "serial,";
                else if (e.carSerial.length !== 3) message += "serialLen,";
                else if (e.carSerial.includes("0")) message += "serialInvalid,";

                if (!e.char) message += "char,";

                if (!e.carOtherNumber) message += "carOtherNumber,";
                else if (e.carOtherNumber.length !== 2)
                  message += "carOtherNumberLen,";
                else if (e.carOtherNumber.includes("0"))
                  message += "carOtherNumberInvalid,";
              }

              //  MOTORCYCLE
              else if (e.type == "MOTOR_CYCLE") {
                if (!e.motorCycleSerial) message += "serial,";
                else if (e.motorCycleSerial.length !== 3)
                  message += "serialLen,";
                else if (e.motorCycleSerial.includes("0"))
                  message += "serialInvalid,";

                if (!e.motorCycleOtherNumber)
                  message += "motorCycleOtherNumber,";
                else if (e.motorCycleOtherNumber.length !== 5)
                  message += "motorCycleOtherNumberLen,";
                else if (e.motorCycleOtherNumber.includes("0"))
                  message += "motorCycleOtherNumberInvalid,";
              }

              //  FREEZONE
              else if (e.type == "FREEZONE") {
                if (!e.serialPlate?.value) message += "serial,";
                if (!e.englishNumber) message += "englishNumber,";
                else if (e.englishNumber.length !==5)
                  message += "englishNumberLen,";
                if (!e.persianNumber) message += "persianNumber,";
                if (!e.selectedZone?.value) message += "zone,";
              }

              return message === "" ? true : message;
            } else return true;
          },
        }}
        render={({ field }) => (
          <Plate
            value={field.value}
            onChange={field.onChange}
            mode={props.mode}
            disabled={props.disabled}
            typeDisabled={props.typeDisabled}
          />
        )}
      />

      {props.errors.plate?.type === "required" && (
        <div className="text-error text-xs">
          {format(t("VALIDATION_ERROR_REQUIRED"), String(t("PLATE")))}
        </div>
      )}

      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes("null,") && (
          <div className="text-error text-xs">
            {format(t("VALIDATION_ERROR_REQUIRED"), String(t("PLATE")))}
          </div>
        )}

      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes("cityCode,") && (
          <div className="text-error text-xs">
            {format(t("VALIDATION_ERROR_REQUIRED"), String(t("CITY_CODE")))}
          </div>
        )}
      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes("cityCodeLen,") && (
          <div className="text-error text-xs">
            {format(
              t("VALIDATION_ERROR_EXACT_STRING_LENGTH"),
              String(t("CITY_CODE")),
              2
            )}
          </div>
        )}
      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes("cityCodeInvalid,") && (
          <div className="text-error text-xs">
            {format(t("VALIDATION_ERROR_INVALID"), String(t("CITY_CODE")))}
          </div>
        )}
      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes("serial,") && (
          <div className="text-error text-xs">
            {format(t("VALIDATION_ERROR_REQUIRED"), String(t("SERIAL")))}
          </div>
        )}
      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes("serialLen,") && (
          <div className="text-error text-xs">
            {format(
              t("VALIDATION_ERROR_EXACT_STRING_LENGTH"),
              String(t("SERIAL")),
              3
            )}
          </div>
        )}
      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes("serialInvalid,") && (
          <div className="text-error text-xs">
            {format(t("VALIDATION_ERROR_INVALID"), String(t("SERIAL")))}
          </div>
        )}
      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes("char,") && (
          <div className="text-error text-xs">
            {format(t("VALIDATION_ERROR_REQUIRED"), String(t("CHAR")))}
          </div>
        )}
      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes("carOtherNumber,") && (
          <div className="text-error text-xs">
            {format(
              t("VALIDATION_ERROR_REQUIRED"),
              String(t("CAR_OTHER_NUMBER"))
            )}
          </div>
        )}
      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes("carOtherNumberLen,") && (
          <div className="text-error text-xs">
            {format(
              t("VALIDATION_ERROR_EXACT_STRING_LENGTH"),
              String(t("CAR_OTHER_NUMBER")),
              2
            )}
          </div>
        )}
      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes(
          "carOtherNumberInvalid,"
        ) && (
          <div className="text-error text-xs">
            {format(
              t("VALIDATION_ERROR_INVALID"),
              String(t("CAR_OTHER_NUMBER"))
            )}
          </div>
        )}

      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes(
          "motorCycleOtherNumber,"
        ) && (
          <div className="text-error text-xs">
            {format(
              t("VALIDATION_ERROR_REQUIRED"),
              String(t("MOTOR_CYCLE_OTHER_NUMBER"))
            )}
          </div>
        )}
      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes(
          "motorCycleOtherNumberLen,"
        ) && (
          <div className="text-error text-xs">
            {format(
              t("VALIDATION_ERROR_EXACT_STRING_LENGTH"),
              String(t("MOTOR_CYCLE_OTHER_NUMBER")),
              5
            )}
          </div>
        )}
      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes(
          "motorCycleOtherNumberInvalid,"
        ) && (
          <div className="text-error text-xs">
            {format(
              t("VALIDATION_ERROR_INVALID"),
              String(t("MOTOR_CYCLE_OTHER_NUMBER"))
            )}
          </div>
        )}

      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes("englishNumber,") && (
          <div className="text-error text-xs">
            {format(
              t("VALIDATION_ERROR_REQUIRED"),
              String(t("ERROR_LENGHT_FREEZONE_CAR"))
            )}
          </div>
        )}
      {props.errors.plate?.type === "validate" &&
        String(props.errors.plate?.message)?.includes("englishNumberLen,") && (
          <div className="text-error text-xs">
            {format(
              t("VALIDATION_ERROR_REQUIRED"),
              String(t("ERROR_LENGHT_FREEZONE_CAR"))
            )}
          </div>
        )}
    </React.Fragment>
  );
};

export default PlateInput;
